import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const root_ = (theme) => ({
  position: "fixed",
  visibility: "hidden",
  pointerEvents: "none",
  zIndex: -1 * theme.zIndex.modal,
  margin: "0px",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
});

const visible_ = (theme) => ({
  position: "fixed",
  visibility: "visible",
  pointerEvents: "auto",
  zIndex: theme.zIndex.modal,
  borderRight: "1px solid rgba(128, 128, 128, 0.5)",
});

const defaultSize_ = (theme) => ({
  maxHeight: "100vh",
  width: "50vw",
  minWidth: 335,
  maxWidth: 600,
  [theme.breakpoints.down("lg")]: {
    width: "80vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "90vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
  },
});

const fullscreenSize_ = (theme) => ({
  width: "100vw",
  height: "100vh",
});

const floatRight_ = (theme) => ({
  marginLeft: "auto",
});

const closeIcon_ = (theme) => ({
  fontSize: 28,
});

export default function Pane({ children, visible, fullscreen, onClose }) {
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Card
      sx={[
        root_,
        defaultSize_,
        visible && visible_,
        fullscreen && fullscreenSize_,
      ]}
    >
      <CardActions disableSpacing>
        <IconButton
          aria-label="Close"
          size="small"
          sx={floatRight_}
          onClick={handleClose}
        >
          <CloseIcon sx={closeIcon_} />
        </IconButton>
      </CardActions>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
